<app-reminders-today [reminders]="reminders$ | async"></app-reminders-today>
